import React from "react";

export default function UnauthorizedPage() {
  return <>Bu sayfaya erişim hakkınız yoktur.</>;
}
